"use strict";
/**
 * @file Created on Wed Aug 12 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DummyWindowSimulationParams_1 = require("../model/DummyWindowSimulationParams");

var DummyWindowSimulationParamsConverter_1 = require("./DummyWindowSimulationParamsConverter");
/**
 * @author Tomas Leity
 */


var DummyWindowSimulationParamsConverterImpl =
/*#__PURE__*/
function (_DummyWindowSimulatio) {
  _inherits(DummyWindowSimulationParamsConverterImpl, _DummyWindowSimulatio);

  function DummyWindowSimulationParamsConverterImpl() {
    _classCallCheck(this, DummyWindowSimulationParamsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowSimulationParamsConverterImpl).apply(this, arguments));
  }

  _createClass(DummyWindowSimulationParamsConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new DummyWindowSimulationParams_1.DummyWindowSimulationParams(DummyWindowSimulationParams_1.DummyWindowSimulationParams.schema.dummyId.valueOf(conversions.toClassReferenceId(source.dummyId)), DummyWindowSimulationParams_1.DummyWindowSimulationParams.schema.windowName.valueOf(source.windowName), DummyWindowSimulationParams_1.DummyWindowSimulationParams.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), DummyWindowSimulationParams_1.DummyWindowSimulationParams.schema.productName.valueOf(source.productName), DummyWindowSimulationParams_1.DummyWindowSimulationParams.schema.promoVolume.valueOf(conversions.toBigNumber(source.promoVolume)), DummyWindowSimulationParams_1.DummyWindowSimulationParams.schema.promoPrice.valueOf(conversions.toBigNumber(source.promoPrice)), DummyWindowSimulationParams_1.DummyWindowSimulationParams.schema.promoPurchasePrice.valueOf(conversions.toBigNumber(source.promoPurchasePrice)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        dummyId: conversions.toDocumentReferenceId(source.dummyId),
        windowName: source.windowName,
        productId: conversions.toDocumentReferenceId(source.productId),
        productName: source.productName,
        promoVolume: conversions.fromBigNumber(source.promoVolume),
        promoPrice: conversions.fromBigNumber(source.promoPrice),
        promoPurchasePrice: conversions.fromBigNumber(source.promoPurchasePrice)
      });
      return result;
    }
  }]);

  return DummyWindowSimulationParamsConverterImpl;
}(DummyWindowSimulationParamsConverter_1.DummyWindowSimulationParamsConverter);

exports.DummyWindowSimulationParamsConverterImpl = DummyWindowSimulationParamsConverterImpl;